export default "__VITE_ASSET__BOmheZtr__"